import clsx from "clsx"
import { FindAllContactsFilters } from "../../../lib/filters/dto"
import { colors } from "../../../ui/colors"
import { StarIcon } from "../../../ui/icons/star"
import { CounterDTO } from "../contacts/dto"
import { ContactStateEnum, stateInfoMap } from "../dto"
import { keycloak } from "../../../lib/keycloak"
import { numericFormatter } from "react-number-format"

interface Props {
    filters: FindAllContactsFilters
    setFilters: (filters: Partial<FindAllContactsFilters>) => void
    counters: CounterDTO | undefined
    isBin: boolean
}
export function OutcomeFilters({ filters, setFilters, counters, isBin }: Props) {
    if (!isBin)
        return (
            <div className={clsx("flex flex-col items-start gap-2 transition-all py-3")}>
                <div className={"flex items-center gap-2"}>
                    <div
                        onClick={() => {
                            if (filters.outcome.map(value => value.value).includes(ContactStateEnum.LEADTAKEN))
                                setFilters({ outcome: filters.outcome.filter(outcome => outcome.value !== ContactStateEnum.LEADTAKEN) })
                            else
                                setFilters({ outcome: [...filters.outcome, { value: ContactStateEnum.LEADTAKEN, label: 'Lead preso' }] })
                        }}
                        className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-green-200", {
                            'border-[2px] border-green-600': filters.outcome.map(value => value.value).includes(ContactStateEnum.LEADTAKEN),
                        })}
                    >
                        <span className="text-green-800 text-label-sm font-medium whitespace-nowrap">
                            Lead preso {numericFormatter(counters?.['inList'].leadTaken.toString() ?? "0", { thousandSeparator: '.' })}
                        </span>
                    </div>
                    <div
                        onClick={() => {
                            if (filters.outcome.map(value => value.value).includes(ContactStateEnum.TORECALL))
                                setFilters({ outcome: filters.outcome.filter(outcome => outcome.value !== ContactStateEnum.TORECALL) })
                            else
                                setFilters({ outcome: [...filters.outcome, { value: ContactStateEnum.TORECALL, label: 'Da richiamare' }] })
                        }}
                        className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-warning-200", {
                            'border-[2px] border-warning-600': filters.outcome.map(value => value.value).includes(ContactStateEnum.TORECALL),
                        })}
                    >
                        <span className="text-warning-800 text-label-sm font-medium whitespace-nowrap">
                            Da richiamare  {numericFormatter(counters?.['inList'].toRecall.toString() ?? "0", { thousandSeparator: '.' })}
                        </span>
                    </div>
                    <div
                        onClick={() => {
                            if (filters.outcome.map(value => value.value).includes(ContactStateEnum.NORESPONSE))
                                setFilters({ outcome: filters.outcome.filter(outcome => outcome.value !== ContactStateEnum.NORESPONSE) })
                            else
                                setFilters({ outcome: [...filters.outcome, { value: ContactStateEnum.NORESPONSE, label: 'Da richiamare' }] })
                        }}
                        className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-warning-300", {
                            'border-[2px] border-warning-700': filters.outcome.map(value => value.value).includes(ContactStateEnum.NORESPONSE),
                        })}
                    >
                        <span className="text-warning-800 text-label-sm font-medium whitespace-nowrap">
                            Nessuna risposta  {numericFormatter(counters?.['inList'].noResponse.toString() ?? "0", { thousandSeparator: '.' })}
                        </span>
                    </div>
                    {!keycloak.hasRealmRole('customer') && !keycloak.hasRealmRole('collaborator') && <div
                        onClick={() => {
                            if (filters.outcome.map(value => value.value).includes(ContactStateEnum.INCORRECT))
                                setFilters({ outcome: filters.outcome.filter(outcome => outcome.value !== ContactStateEnum.INCORRECT) })
                            else
                                setFilters({ outcome: [...filters.outcome, { value: ContactStateEnum.INCORRECT, label: 'Info errate' }] })
                        }}
                        className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-neutral-200", {
                            'border-[2px] border-neutral-600': filters.outcome.map(value => value.value).includes(ContactStateEnum.INCORRECT),
                        })}
                    >
                        <span className="text-neutral-800 text-label-sm font-medium whitespace-nowrap">
                            Info errate e aggiornate {numericFormatter(counters?.['inList'].incorrect.toString() ?? "0", { thousandSeparator: '.' })}
                        </span>
                    </div>}
                    <div
                        onClick={() => {
                            if (filters.outcome.map(value => value.value).includes(ContactStateEnum.DRAFT))
                                setFilters({ outcome: filters.outcome.filter(outcome => outcome.value !== ContactStateEnum.DRAFT) })
                            else
                                setFilters({ outcome: [...filters.outcome, { value: ContactStateEnum.DRAFT, label: 'Da lavorare' }] })
                        }}
                        className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-brandPrimary-200", {
                            'border-[2px] border-brandPrimary-600': filters.outcome.map(value => value.value).includes(ContactStateEnum.DRAFT)
                        })}
                    >
                        <span className="text-brandPrimary-800 text-label-sm font-medium whitespace-nowrap">
                            Da lavorare {numericFormatter(counters?.['inList'].draft.toString() ?? "0", { thousandSeparator: '.' })}
                        </span>
                    </div>
                    {!keycloak.hasRealmRole('customer') && <div
                        onClick={() => {
                            if (filters.favorite?.value === 'true')
                                setFilters({ favorite: undefined })
                            else
                                setFilters({ favorite: { value: 'true', label: 'Sì' } })
                        }}
                        className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-brandSecondary-200", {
                            'border-[2px] border-brandSecondary-600': filters.favorite?.value === 'true',
                        })}
                    >
                        <StarIcon active={true} color={colors.brandSecondary[800]} size={12} />
                        <span className="text-brandSecondary-800 text-label-sm font-medium whitespace-nowrap">
                            Preferiti {numericFormatter(counters?.['inList'].favorite.toString() ?? "0", { thousandSeparator: '.' })}
                        </span>
                    </div>}
                </div>
                {
                    filters.outcome.map(o => o.value).includes(ContactStateEnum.TORECALL) &&
                    <div className={"flex items-center gap-2"}>
                        {
                            stateInfoMap(ContactStateEnum.TORECALL).map((info, index) =>
                                <div
                                    onClick={() => {
                                        if (filters.outcomeInfo.map(value => value.value).includes(info))
                                            setFilters({ outcomeInfo: filters.outcomeInfo.filter(outcome => outcome.value !== info) })
                                        else
                                            setFilters({ outcomeInfo: [...filters.outcomeInfo, { value: info, label: info }] })
                                    }}
                                    className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-warning-200", {
                                        'border-[2px] border-warning-600': filters.outcomeInfo.map(value => value.value).includes(info)
                                    })}
                                >
                                    <span className="text-warning-800 text-label-sm font-medium whitespace-nowrap">
                                        {info}
                                    </span>
                                </div>
                            )
                        }
                    </div>
                }
            </div>
        )

    return (
        <div className={clsx("flex items-start gap-2 transition-all py-3")}>
            {
                stateInfoMap(ContactStateEnum.KO).map((info, index) =>
                    <div
                        onClick={() => {
                            if (filters.outcomeInfo.map(value => value.value).includes(info))
                                setFilters({ outcomeInfo: filters.outcomeInfo.filter(outcome => outcome.value !== info) })
                            else
                                setFilters({ outcomeInfo: [...filters.outcomeInfo, { value: info, label: info }] })
                        }}
                        className={clsx("cursor-pointer flex items-center h-full px-2 py-1 gap-2 rounded-[4px] bg-red-200", {
                            'border-[2px] border-red-600': filters.outcomeInfo.map(value => value.value).includes(info)
                        })}
                    >
                        <span className="text-red-800 text-label-sm font-medium whitespace-nowrap">
                            {info}
                        </span>
                    </div>
                )
            }
        </div>
    )
}